import React from 'react';
import { Users, BookOpen, Star, ShieldCheck } from 'lucide-react';
const publications = ['Bon Appétit', 'Saveur', 'Food & Wine', 'Travel + Leisure', 'Eater', 'Condé Nast Traveler'];
const stats = [{
  icon: Users,
  value: '8,427+',
  label: 'Happy Home Cooks'
}, {
  icon: BookOpen,
  value: '12',
  label: 'Resort Recipes'
}, {
  icon: Star,
  value: '4.9 / 5',
  label: 'Average Rating'
}, {
  icon: ShieldCheck,
  value: '30 Days',
  label: 'Money-Back Guarantee'
}];
export function FeaturedIn() {
  return <section className="w-full bg-[#3E2723] py-12 md:py-16" data-id="element-225">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-226">
        <div className="text-center mb-10" data-id="element-227">
          <div className="text-xs md:text-sm uppercase tracking-[0.3em] text-yellow-300 font-bold mb-6" data-id="element-228">
            As Featured In
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-8 md:gap-x-12 gap-y-4" data-id="element-229">
            {publications.map(pub => <div key={pub} className="text-white/70 hover:text-white transition-colors text-base md:text-xl font-bold tracking-wide italic" style={{
            fontFamily: 'DM Serif Display, serif'
          }} data-id="element-230">
                {pub}
              </div>)}
          </div>
        </div>

        <div className="border-t border-white/10 pt-10 mt-10" data-id="element-231">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-232">
            {stats.map(stat => {
            const Icon = stat.icon;
            return <div key={stat.label} className="text-center" data-id="element-233">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#C2410C] mb-3" data-id="element-234">
                    <Icon className="w-6 h-6 text-yellow-300" data-id="element-235" />
                  </div>
                  <div className="text-3xl md:text-4xl font-extrabold text-white leading-none mb-1" data-id="element-236">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/70 uppercase tracking-wider" data-id="element-237">
                    {stat.label}
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}